import type { CaregiverRelationshipKind } from '../../../__generated__/globalTypes';
import type { IDateOfBirthValue } from '@orn/shared-web/components/DateOfBirthInput';

export type IDependantDateOfBirth = IDateOfBirthValue;

export interface IDependantFormValues {
  relationship: CaregiverRelationshipKind | null;
  isStep: boolean;
  isInLaw: boolean;
  firstName: string;
  lastName: string;
  preferredName: string;
  dateOfBirth: IDependantDateOfBirth | null;
}

export const createEmptyDependantFormValues = (): IDependantFormValues => ({
  relationship: null,
  isStep: false,
  isInLaw: false,
  firstName: '',
  lastName: '',
  preferredName: '',
  dateOfBirth: null,
});
